import { defineStore } from "pinia";
import { ref } from "vue";
import { API } from "@/queries/index";
import { AxiosError } from "axios";
import { APIResponse, APIResponseError } from "@/types/api";
import { handleResponse, handleResponseError } from "@/utils/api";
import { MenuRolePayload, MenuRolePayloadUpdate, MenuRoleResponse } from "@/types/interface/menu-role";

export const useMenuRole = defineStore("menuRoleStore", () => {
  const menu = ref<MenuRoleResponse>();
  const menus = ref<MenuRoleResponse[]>([]);

  function initMenuRoles(data: any) {
    menus.value = data;
  }

  function addMenuRole(data: any) {
    menu.value = data;
  }

  async function dispatchGetAll(idMenuRole = 0) : Promise<APIResponse<null>> {
    try {
      const { status, data } = await API.menuRole.getMenuRole(idMenuRole);
      if (status === 200 ) {
        initMenuRoles(data);
        return handleResponse(status, data);
      }
    } catch (error) {
      const _error = error as AxiosError<APIResponseError>;
      const errorResponseData = _error.response?.data
      return handleResponseError(errorResponseData)
    }
    return handleResponse(200, null);
  }

  async function dispatchDetail(idMenuRole = "") : Promise<APIResponse<null>> {
    try {
      const { status, data } = await API.menuRole.findMenuRole(idMenuRole);
      if (status === 200 ) {
        addMenuRole(data);
        return handleResponse(status, data);
      }
    } catch (error) {
      const _error = error as AxiosError<APIResponseError>;
      const errorResponseData = _error.response?.data
      return handleResponseError(errorResponseData)
    }
    return handleResponse(200, null);
  }

  async function dispatchCreate(payload:MenuRolePayload) : Promise<APIResponse<null>> {
    try {
      const { status, data } = await API.menuRole.createMenuRole(payload);
      if (status === 200 ) {
        addMenuRole(data);
        return handleResponse(status, data);
      }
    } catch (error) {
      const _error = error as AxiosError<APIResponseError>;
      const errorResponseData = _error.response?.data
      return handleResponseError(errorResponseData)
    }
    return handleResponse(200, null);
  }

  async function dispatchUpdate(payload:MenuRolePayloadUpdate) : Promise<APIResponse<null>> {
    try {
      const { status, data } = await API.menuRole.updateMenuRole(payload);
      if (status === 200 ) {
        addMenuRole(data);
        return handleResponse(status, data);
      }
    } catch (error) {
      const _error = error as AxiosError<APIResponseError>;
      const errorResponseData = _error.response?.data
      return handleResponseError(errorResponseData)
    }
    return handleResponse(200, null);
  }

  async function dispatchDelete(idMenuRole = "") : Promise<APIResponse<null>> {
    try {
      const { status, data } = await API.menuRole.deleteMenuRole(idMenuRole);
      if (status === 200 ) {
        return handleResponse(status, data);
      }
    } catch (error) {
      const _error = error as AxiosError<APIResponseError>;
      const errorResponseData = _error.response?.data
      return handleResponseError(errorResponseData)
    }
    return handleResponse(200, null);
  }

  return {
    menu,
    menus,
    initMenuRoles,
    dispatchCreate,
    dispatchUpdate,
    dispatchDetail,
    dispatchGetAll,
    dispatchDelete
  };
});